import Vue from 'vue';
import Vuex from 'vuex';
import api from './api';

Vue.use(Vuex);

const moduleAFMP = {
  state: {
    courseTypes: [],
    selectedIndex: 0,
  },

  getters: {
    getActiveCoursesTypes(state) {
      return state.courseTypes[state.selectedIndex];
    },
  },
};

// 订单模块
const moduleOrder = {
  namespaced: true,
  state: {
    liveOrderStateList: [
      {
        value: 'NOT_PAY',
        label: '未支付',
      },
      {
        value: 'CANCEL',
        label: '订单超时',
      },
      {
        value: 'FAIL',
        label: '支付失败',
      },
      {
        value: 'SUCCESS',
        label: '支付成功',
      },
      {
        value: 'COMPLETE',
        label: '已完成',
      },
    ],
  },
  getters: {
    getOrderStateText: state => (value) => {
      let text = '';
      for (let i = 0, l = state.liveOrderStateList.length; i < l; i += 1) {
        if (value === state.liveOrderStateList[i].value) {
          text = state.liveOrderStateList[i].label;
        }
      }
      return text;
    },
  },
};

// 文档模块
const documentModule = {
  namespaced: true,
  state: {
    breadcrumbList: [
      {
        name: '文档分类列表',
        to: '',
      },
    ],
  },
  mutations: {
    setBreadcrumb(state, data) {
      state.breadcrumbList = data;
    },
  },
};

export default new Vuex.Store({
  state: {
    // 菜单树
    menuData: null,
    // 菜单列表
    menuList: null,
    // 动态路由菜单列表
    regexpMenuList: [],
    // 新手指引
    newGuideIdx:5
  },

  getters: {
    getMenuData(state) {
      return state.menuData;
    },

    getMenuList(state) {
      return state.menuList;
    },

    getRegexpMenuList(state, data) {
      return state.regexpMenuList;
    },
  },

  mutations: {
    setMenuData(state, data) {
      state.menuData = data;
    },

    setMenuList(state, data) {
      state.menuList = data;
    },

    addRegexpMenuList(state, data) {
      // const list = JSON.parse(JSON.stringify(state.regexpMenuList));
      // list.push(data);
      state.regexpMenuList = data;
    },
  },
  actions: {
    getAdminMenuData() {
      return api.auth.getLoginMenu();
    },

  },

  modules: {
    AFMP: moduleAFMP,
    order: moduleOrder,
    document: documentModule,
  },
});
